/* ESTEN v14 motion: sunset sky with three layers of hazy, sun-lit rocky mountains, a limb-darkened sun and water made of many travelling waves (different sizes, directions and speeds) with real reflections and sun glitter (waves run at 60% speed and stay visible all the way to the horizon, fading with distance).
   Always animated (also on phones with Reduce Motion on, by request). Sharp render, 30 fps, paused off screen. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  function initSky(hero) {
    var cv = $('.esten-sky', hero); if (!cv || cv.dataset.on) return; cv.dataset.on = '1';
    var gl = null, U = null, shown = true, last = 0;
    try { gl = cv.getContext('webgl', { antialias: true, alpha: false, powerPreference: 'low-power' }); } catch (e) {}
    if (!gl) { hero.classList.add('no-gl'); return; }
    var FRAG = [
'precision highp float;',
'uniform vec2 R; uniform float T; uniform float P;',
'const float HZ=.34; const float FOV=.9; const float CH=1.4;',
'float hash(vec2 p){p=fract(p*vec2(123.34,456.21));p+=dot(p,p+45.32);return fract(p.x*p.y);}',
'float noise(vec2 p){vec2 i=floor(p),f=fract(p);vec2 u=f*f*(3.-2.*f);return mix(mix(hash(i),hash(i+vec2(1,0)),u.x),mix(hash(i+vec2(0,1)),hash(i+vec2(1,1)),u.x),u.y);}',
'float fbm(vec2 p){float v=0.,a=.5;for(int i=0;i<5;i++){v+=a*noise(p);p=p*2.02+vec2(1.7,9.2);a*=.5;}return v;}',
'float ridged(float x,float s){float v=0.,a=.55,f=1.;for(int i=0;i<7;i++){float n=noise(vec2(x*f,s+float(i)*13.1));n=1.-abs(n*2.-1.);v+=a*n*n;f*=2.07;a*=.47;}return v;}',
'float terr(vec2 q){float v=0.,a=.5;for(int i=0;i<5;i++){float n=noise(q);n=1.-abs(n*2.-1.);v+=a*n*n;q=q*2.03+vec2(3.1,1.7);a*=.5;}return v;}',
'vec3 above(vec2 uv,vec2 sp,float sr,float p,float asp,float px){',
'  float e=max(uv.y-HZ,0.);',
'  vec3 zen=mix(vec3(.12,.19,.34),vec3(.015,.02,.045),p);',
'  vec3 mid=mix(vec3(.80,.42,.25),vec3(.08,.11,.21),smoothstep(0.,.85,p));',
'  vec3 low=mix(vec3(1.,.76,.42),vec3(.34,.19,.26),smoothstep(0.,.9,p));',
'  vec3 c=mix(low,mid,smoothstep(0.,.16,e)); c=mix(c,zen,smoothstep(.1,.62,e));',
'  float r=length((uv-sp)*vec2(asp,1.));',
'  c+=vec3(1.,.58,.28)*exp(-r*5.)*.55*(1.-p*.85);',
'  c+=vec3(1.,.8,.5)*exp(-r*18.)*.5*(1.-p);',
'  float cl=fbm(vec2(uv.x*2.2+T*.006,uv.y*13.));',
'  cl=smoothstep(.56,.82,cl)*smoothstep(HZ+.08,HZ+.16,uv.y)*(1.-smoothstep(HZ+.3,HZ+.5,uv.y));',
'  vec3 cc=mix(vec3(1.,.58,.38),vec3(.22,.16,.26),smoothstep(0.,.8,p))*(1.+.8*exp(-r*3.)*(1.-p));',
'  c=mix(c,cc,cl*.7);',
'  float ds=length((uv-sp)*vec2(asp,1.12));',
'  float disc=1.-smoothstep(sr-px*1.5,sr+px*1.5,ds);',
'  float limb=sqrt(max(0.,1.-ds*ds/(sr*sr)));',
'  vec3 sc=mix(vec3(1.,.5,.18),vec3(1.,.94,.76),pow(limb,.6));',
'  sc=mix(sc,vec3(.98,.38,.14),smoothstep(0.,.7,p)*.6);',
'  c=mix(c,sc,disc);',
'  vec3 hz=mix(low,mid,.15);',
'  float ax=uv.x*asp; float dsx=abs(uv.x-sp.x);',
'  float sunGlow=(1.-p)*exp(-dsx*4.);',
'  float env=.35+.65*smoothstep(.02,.3,dsx);',
'  float fr=ridged(ax*.7+2.3,1.); float fh=HZ+.004+.16*fr*fr*env;',
'  float fm=1.-smoothstep(fh-px,fh+px,uv.y);',
'  vec3 farC=mix(mix(vec3(.62,.38,.36),vec3(.14,.13,.21),p),hz,.5);',
'  farC+=vec3(1.,.66,.4)*exp(-max(fh-uv.y,0.)/px*.15)*.22*sunGlow;',
'  c=mix(c,farC,fm);',
'  float mr=ridged(ax*1.05+5.1,3.); float mh=HZ+.003+.12*mr*mr*(.4+.6*smoothstep(.0,.28,dsx));',
'  float mm=1.-smoothstep(mh-px,mh+px,uv.y);',
'  vec3 midC=mix(mix(vec3(.42,.24,.24),vec3(.08,.08,.13),p),hz,.26);',
'  float m0=terr(vec2(ax*9.,uv.y*4.)), mxx=terr(vec2(ax*9.+.04,uv.y*4.));',
'  midC*=.82+.32*clamp(.5+(mxx-m0)/.04*.5*clamp((sp.x-uv.x)*14.,-1.,1.),0.,1.)+.08*m0;',
'  midC+=vec3(1.,.62,.35)*exp(-max(mh-uv.y,0.)/px*.16)*.3*sunGlow;',
'  c=mix(c,midC,mm);',
'  float ne=.45+.55*smoothstep(0.,.36,abs(uv.x-sp.x+.06));',
'  float nx=ax*1.55+8.7;',
'  float rn=ridged(nx,5.);',
'  float nh=HZ+.002+.11*pow(rn,2.4)*ne;',
'  float nm=1.-smoothstep(nh-px,nh+px,uv.y);',
'  float below=max(nh-uv.y,0.);',
'  float L=clamp((sp.x-uv.x)*14.,-1.,1.);',
// relief: gullies running down the slopes (stretched vertically) + finer rock, lit from the sun side
'  vec2 q=vec2(ax*13.+uv.y*6.*L,uv.y*13.);',
'  float ex=.035;',
'  float t0=terr(q), tx=terr(q+vec2(ex,0.)), ty=terr(q+vec2(0.,ex));',
'  vec2 q2=vec2(ax*48.,uv.y*20.);',
'  float u0=noise(q2), ux=noise(q2+vec2(.08,0.));',
'  float slopeX=(tx-t0)/ex*.55+(ux-u0)/.08*.2;',
'  float shade=clamp(.5+slopeX*L*.55+(ty-t0)/ex*.12,0.,1.25);',
'  float r1=ridged(nx+.01,5.),r0=ridged(nx-.01,5.); float face=clamp(-(r1*r1-r0*r0)*L*6.,-1.,1.);',
'  shade=clamp(shade*.75+face*.45+.12,0.,1.3);',
'  vec3 shadowC=mix(vec3(.17,.10,.12),vec3(.03,.035,.06),p);',
'  vec3 litC=mix(vec3(.62,.37,.27),vec3(.12,.11,.16),p);',
'  vec3 nearC=mix(shadowC,litC,shade*(.55+.45*sunGlow+.25));',
'  nearC*=.88+.24*t0;',
'  nearC+=vec3(1.,.64,.36)*exp(-below/px*.22)*.5*(.35+.65*sunGlow);',
'  nearC=mix(nearC,vec3(1.,.62,.35),exp(-below*90.)*.12*(.3+.7*sunGlow));',
'  nearC=mix(nearC,hz*.55,smoothstep(HZ+.025,HZ,uv.y)*.4);',
'  c=mix(c,nearC,nm);',
'  return c;',
'}',
'void main(){',
'  vec2 uv=gl_FragCoord.xy/R; float p=P; float asp=R.x/R.y; float px=1./R.y;',
'  float sr=.07*min(1.,1.5/asp);',
'  vec2 sp=vec2(.62,HZ+sr*.9-p*sr*1.5);',
'  vec3 col;',
'  if(uv.y>=HZ){',
'    col=above(uv,sp,sr,p,asp,px);',
'  } else {',
'    vec3 dir=normalize(vec3((uv.x-.5)*asp*FOV,(uv.y-HZ)*FOV,1.));',
'    float tt=CH/max(-dir.y,1e-4); vec2 WP=vec2(dir.x,dir.z)*tt;',
'    float fp=tt*tt*px*FOV/CH;',
'    vec2 g=vec2(0.); float lam=5.2; float att=max(pow(.7,log2(1.+tt/4.)),.18);',
'    for(int i=0;i<13;i++){',
'      float fi=float(i);',
'      float a=-1.5708+(hash(vec2(fi,3.7))-.5)*2.2;',
'      vec2 D=vec2(cos(a),sin(a));',
'      float k=6.2832/lam; float w=sqrt(9.81*k)*.62;',
'      float amp=lam*.03*(.45+.55*noise(WP*.35/lam+vec2(T*.042,fi*7.3)));',
'      amp*=exp(-pow(k*fp*.55,2.))*att;',
'      float ph=dot(D,WP)*k+T*.6*w+hash(vec2(fi,9.1))*6.2832;',
'      g+=D*(amp*k*cos(ph));',
'      lam*=.71;',
'    }',
'    float hz01=(HZ-uv.y)/HZ; float far=1.-smoothstep(.0,.45,hz01);',
'    vec2 sq=vec2(uv.x*asp*7.+T*.04,(HZ-uv.y)*R.y*.32-T*.8);',
'    float s1=noise(sq), s2=noise(sq*vec2(1.7,1.3)+5.2);',
'    g+=vec2((s1-.5)*.035,(s2-.5)*.075)*far*(.45+.55*smoothstep(.0,.08,hz01));',
'    vec3 n=normalize(vec3(-g.x*.6,1.,-g.y*.5));',
'    vec3 rd=reflect(dir,n); rd.y=max(rd.y,.002);',
'    vec2 ruv=vec2(rd.x/rd.z/(asp*FOV)+.5,rd.y/rd.z/FOV+HZ);',
'    vec3 rc=above(ruv,sp,sr,p,asp,px*2.);',
'    float fres=.04+.96*pow(1.-max(dot(-dir,n),0.),5.);',
'    float depth=(HZ-uv.y)/HZ;',
'    vec3 deep=mix(vec3(.16,.10,.09),vec3(.03,.03,.05),p);',
'    col=mix(deep,rc*vec3(.88,.92,1.),clamp(fres*1.2+.45,0.,1.))*mix(.95,.68,depth);',
'    vec3 Ls=normalize(vec3((sp.x-.5)*asp*FOV,(sp.y-HZ)*FOV,1.));',
'    float sd=max(dot(rd,Ls),0.);',
'    float spark=pow(sd,1400.)*5.+pow(sd,220.)*.7+pow(sd,40.)*.10;',
'    col+=vec3(1.,.8,.52)*spark*(1.-smoothstep(0.,1.,p*1.15));',
'  }',
'  col+=vec3(1.,.85,.6)*exp(-abs(uv.y-HZ)*R.y*.35)*.18*(1.-p*.7);',
'  vec2 q=uv-.5; col*=1.-.38*dot(q,q);',
'  col+=(hash(gl_FragCoord.xy+fract(T))-.5)*.012;',
'  gl_FragColor=vec4(col,1.);',
'}'
].join('\n');
    try {
      var sh = function (t, s) { var o = gl.createShader(t); gl.shaderSource(o, s); gl.compileShader(o); if (!gl.getShaderParameter(o, gl.COMPILE_STATUS)) throw gl.getShaderInfoLog(o); return o; };
      var pr = gl.createProgram();
      gl.attachShader(pr, sh(gl.VERTEX_SHADER, 'attribute vec2 a;void main(){gl_Position=vec4(a,0.,1.);}'));
      gl.attachShader(pr, sh(gl.FRAGMENT_SHADER, FRAG)); gl.linkProgram(pr);
      if (!gl.getProgramParameter(pr, gl.LINK_STATUS)) throw gl.getProgramInfoLog(pr);
      gl.useProgram(pr);
      var b = gl.createBuffer(); gl.bindBuffer(gl.ARRAY_BUFFER, b); gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1, -1, 3, -1, -1, 3]), gl.STATIC_DRAW);
      var loc = gl.getAttribLocation(pr, 'a'); gl.enableVertexAttribArray(loc); gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);
      U = { R: gl.getUniformLocation(pr, 'R'), T: gl.getUniformLocation(pr, 'T'), P: gl.getUniformLocation(pr, 'P') };
    } catch (e) { hero.classList.add('no-gl'); return; }
    function fit() {
      var w = cv.clientWidth, h = cv.clientHeight, scale = Math.min(window.devicePixelRatio || 1, 1.5);
      if (w * h * scale * scale > 2e6) scale = Math.sqrt(2e6 / (w * h));
      cv.width = Math.max(1, Math.round(w * scale)); cv.height = Math.max(1, Math.round(h * scale));
      gl.viewport(0, 0, cv.width, cv.height);
    }
    function draw(now) { var t = now / 1000; gl.uniform2f(U.R, cv.width, cv.height); gl.uniform1f(U.T, t); gl.uniform1f(U.P, .2 + .05 * Math.sin(t / 18)); gl.drawArrays(gl.TRIANGLES, 0, 3); }
    fit(); draw(0);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(function () { fit(); draw(performance.now()); }, 150); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { shown = e[0].isIntersecting; }).observe(hero);
    (function loop(now) { if (shown && !document.hidden && now - last > 33) { last = now; draw(now); } requestAnimationFrame(loop); })(0);
  }

  function initReveals() {
    var els = $$('.esten-rv:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } }); }, { threshold: .12 });
    els.forEach(function (el) { io.observe(el); });
  }

  var anchorsOn = false;
  function quickAnchors() {
    if (anchorsOn) return; anchorsOn = true;
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#esten-"]'); if (!a) return;
      var t = document.querySelector(a.getAttribute('href')); if (!t) return;
      e.preventDefault();
      var hd = document.querySelector('#header-component'); var hh = hd ? hd.offsetHeight : 0;
      var y = Math.max(0, t.getBoundingClientRect().top + window.scrollY - hh + 4);
      var s = window.scrollY, dist = y - s, st = performance.now(), D = 420;
      (function f(n) { var p = Math.min(1, (n - st) / D), k = 1 - Math.pow(1 - p, 3); window.scrollTo(0, s + dist * k); if (p < 1) requestAnimationFrame(f); })(st);
    });
  }

  function boot() {
    $$('.esten-hero').forEach(initSky);
    initReveals();
    quickAnchors();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
